export function deriveSourceAttributeLabel(
  sourceLabel: string | null | undefined,
  sourceFieldId: string,
): string {
  const label = sourceLabel?.trim();
  return label || sourceFieldId;
}
